import axios from 'axios'
import router from '@/router'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '',
    timeout: 20000,
})

function expireSession() {
    const currentRoute = router.currentRoute || {}
    const currentPath = currentRoute.path || ''
    const isStaffRoute = currentPath.indexOf('/staff/') === 0
    const isCheckinRoute = currentPath.indexOf('/checkin/') === 0
    if (isCheckinRoute) localStorage.removeItem('checkin_token')
    else localStorage.removeItem('front_token')
    window.dispatchEvent(new Event('auth-changed'))
    // 评审端会话失效后回到独立专家登录页，并保留重新登录后的回跳地址。
    if (isStaffRoute) {
        if (currentPath !== '/staff/login') {
            router.replace({
                path: '/staff/login',
                query: { redirect: currentRoute.fullPath || '/staff/reviews' },
            }).catch(() => {})
        }
        return
    }
    if (isCheckinRoute) {
        if (currentPath !== '/checkin/login') {
            router.replace({ path: '/checkin/login', query: { redirect: currentRoute.fullPath || '/checkin/events' } }).catch(() => {})
        }
        return
    }
    if (currentPath !== '/') router.replace('/').catch(() => {})
}

function isPasswordValidationFailure(error) {
    const url = error && error.config && error.config.url
    const message = error && error.response && error.response.data && error.response.data.msg
    return /\/api\/website\/auth\/password\/change(?:$|\?)/.test(String(url || ''))
        && String(message || '').indexOf('当前密码') !== -1
}

function isLoginValidationFailure(error) {
    const url = error && error.config && error.config.url
    return /\/api\/website\/auth\/login(?:\/code)?(?:$|\?)/.test(String(url || ''))
}

// 添加请求拦截器
service.interceptors.request.use(
    function (config) {
        const currentPath = router.currentRoute && router.currentRoute.path || ''
        const token = currentPath.indexOf('/checkin/') === 0
            ? localStorage.getItem('checkin_token')
            : localStorage.getItem('front_token')
        if (token) config.headers.Authorization = `Bearer ${token}`
        return config
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
service.interceptors.response.use(
    function (res) {
        // 文件预览/下载使用Blob响应，不按AjaxResult解析。
        if (res.config && res.config.responseType === 'blob') return res
        const data = res.data
        if (data && data.code && data.code !== 200) {
            const responseError = { config: res.config, response: { data } }
            // 登录接口的 401 是本次凭据校验失败，不是已有会话过期，应留在登录页。
            if (data.code === 401 && !isPasswordValidationFailure(responseError) && !isLoginValidationFailure(responseError)) expireSession()
            if (window.alertErr) window.alertErr(data.msg || '请求失败')
            return Promise.reject(new Error(data.msg || '请求失败'))
        }
        return data
    },
    function (error) {
        // 当前密码校验失败不代表官网会话失效，不能把用户强制退出。
        if (error.response && error.response.status === 401 && !isPasswordValidationFailure(error) && !isLoginValidationFailure(error)) {
            expireSession()
        }
        const status = error.response && error.response.status
        const serverMessage = error.response && error.response.data && error.response.data.msg
        const message = serverMessage || (status === 404 ? '服务暂时不可用，请稍后重试' : status >= 500 ? '服务开小差了，请稍后重试' : error.message || '网络请求失败')
        if (window.alertErr) window.alertErr(message)
        return Promise.reject(error)
    }
)

export function api(action, method, data) {
    const reqMethod = (method || 'get').toLowerCase()
    return service({
        url: action,
        method: reqMethod,
        params: reqMethod === 'get' ? data : undefined,
        data: reqMethod !== 'get' ? data : undefined,
    })
}

export function fileApi(action, method) {
    return service({
        url: action,
        method: (method || 'get').toLowerCase(),
        responseType: 'blob',
    })
}

export default service
